// Connects to data-controller="components--toggle-submit".
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["input", "button"]

    connect() {
        this.updateState = this.updateState.bind(this)
        this.inputTargets.forEach(input => input.addEventListener("change", this.updateState))
        window.addEventListener("pageshow", this.updateState)
        this.updateState()
    }

    disconnect() {
        this.inputTargets.forEach(input => input.removeEventListener("change", this.updateState))
        window.removeEventListener("pageshow", this.updateState)
    }

    updateState() {
        const anySelected = this.inputTargets.some(el => el.checked)
        this.buttonTarget.disabled = !anySelected
    }
}
